import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const FTLPTLDeliveredIntransit = ({ delivered, intransit }) => {
    const [delivered1, setDelivered1] = useState([0]); // Default initialized to avoid undefined issues
    const [intransit1, setIntransit1] = useState([0]);  // Default initialized to avoid undefined issues

    useEffect(() => {
        // Ensure values are numbers or default them to 0
        const DeliveredValue = delivered || 0;
        const IntransitValue = intransit || 0;


        setDelivered1([DeliveredValue]); // Delivered data for FTL and PTL
        setIntransit1([IntransitValue]);  // In-Transit data for FTL and PTL
    }, [delivered, intransit, ]);
    const dStyles={
        width:'100%',
        height:'100%'
}
    const options = {
        chart: {
            type: 'column',
            // height: 250
        },
        title: {
            text: 'Consignments Delivered and Undelivered Status',
            // align: 'left'
        },
        xAxis: {
            categories: ["Consignments"], // Categories represent FTL and PTL
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: "No of Shipments(%)"
            },
            labels: {
                formatter: function () {
                    return this.value;
                }
            },
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y}%</b>',  // Add % in tooltip
        },
        plotOptions: {
            column: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    style: {
                        color: 'black',
                        textOutline: 'none'
                    },
                    formatter: function () {
                        return this.y + '%';  // Add % next to the value in the data labels
                    },
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -10,
                    x: 0
                }
            }
        },
        colors: ["#1cc88a","#28bad4"],
        series: [
            {
                name: 'Delivered',  // Legend will show "Delivered"
                data: delivered1// FTL and PTL delivered data in one series
            },
            {
                name: 'Undelivered',  // Legend will show "In-Transit"
                data: intransit1 // FTL and PTL in-transit data in one series
            }
        ],
        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        }
    };

    return (
        <div>
            {/* <div className='d-flex justify-content-between'>
                <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>FTL & PTL Delivery and Intransit Status</h1>
            </div> */}
            {/* Ensure the data is correctly logged before rendering */}
            <HighchartsReact highcharts={Highcharts} styles={dStyles} options={options} />
        </div>
    );
};

export default FTLPTLDeliveredIntransit;
